import { render, staticRenderFns } from "./nutritionLoader.vue?vue&type=template&id=ed0a184e&scoped=true"
var script = {}
import style0 from "./nutritionLoader.vue?vue&type=style&index=0&id=ed0a184e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0a184e",
  null
  
)

export default component.exports